var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenuGraph = function SvgMenuGraph(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "MG_1_",
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MG_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MG_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MG_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#63666A",
    strokeMiterlimit: 10,
    d: "M34.467,24.925c0,1.252-1.016,2.268-2.268,2.268H7.801 c-1.252,0-2.268-1.016-2.268-2.268V10.491c0-1.253,1.015-2.268,2.268-2.268h24.398c1.252,0,2.268,1.015,2.268,2.268V24.925z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 10.49,
    y1: 32.486,
    x2: 29.51,
    y2: 32.486
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 15.525,
    y1: 27.193,
    x2: 15.525,
    y2: 30.446
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 24.451,
    y1: 27.193,
    x2: 24.451,
    y2: 30.446
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MG_2_)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.897,
    y: 14.634,
    fill: "#00C752",
    width: 2,
    height: 8.604
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.083,
    y: 12.003,
    fill: "#00C752",
    width: 2,
    height: 11.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.269,
    y: 17.948,
    fill: "#00C752",
    width: 2,
    height: 5.289
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00C752",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.215,
    y1: 12.521,
    x2: 30.506,
    y2: 12.521
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00C752",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.215,
    y1: 15.066,
    x2: 30.506,
    y2: 15.066
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00C752",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.215,
    y1: 17.611,
    x2: 30.506,
    y2: 17.611
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00C752",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.215,
    y1: 20.155,
    x2: 30.506,
    y2: 20.155
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00C752",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.215,
    y1: 22.7,
    x2: 26.002,
    y2: 22.7
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    clipPath: "url(#MG_2_)",
    fill: "none",
    width: 40,
    height: 40
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-graph.485cb7aa.svg";
export { ForwardRef as ReactComponent };